import { Flex,  Stack, Heading, Text, Box, Divider, Spinner} from "@chakra-ui/react";
import { FormEvent, useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Shippment } from "../../../shared";
import { getShippByIdRequest, getShippByIdResponse, getUserByIdRequest, getUserResponse } from "../../../shared/src/api";
import { withParams, ENDPOINT_CONFIGS } from "../endpoints";
import { ApiError, callEndpoint } from "../fetch";
import { isAdmin, isCaptin, isLoggedIn } from "../fetch/auth";
import { ROUTES } from "../routes";
import { CHARGE_STATES, RECEIVE_OPTIONS, STATES,STATES_NAMES, USER_STATUS } from "../types";


export const  ShippById = () =>{ 
  const [error, setError] = useState('');
  const [tempShipp, setTempShipp]= useState({});
  const [shipp, setShipp]= useState({} as Shippment);
  const [busy, setBusy] = useState(true);
  const { id: shippId } = useParams();
const [senderDetls, setSenderDtls] = useState('');

  const navigate = useNavigate();
    const Admin=isAdmin();
   const is_captin = isCaptin();

    if (!isLoggedIn()) {
        navigate(ROUTES.SIGN_IN);
    }

    useEffect(()=>{ 
      const fetchData = async()=>{
      try{
        const res= await callEndpoint<getShippByIdRequest, getShippByIdResponse>(withParams(ENDPOINT_CONFIGS.getShipp, shippId!))   
          setTempShipp({
            "كود الطرد":res.shipp.id,
            "حالة التنفيذ":STATES[res.shipp.state],
            ...(res.shipp.state>STATES_NAMES.WITH_CAPTIN)&&{"ملاحظات التنفيذ":res.shipp.execNotes},
            "كود الراسل":res.shipp.senderId,
            "عنوان الراسل":res.shipp.senderAddress,  
            "محتوى الطرد":res.shipp.description,           
            "اسم المستلم":res.shipp.conName,
            "عنوان المستلم":res.shipp.addrees,
            "تليفون المستلم":res.shipp.consMobile,
            "استلام مرتجع":RECEIVE_OPTIONS[res.shipp.receiveState],
            "وصف المرتجع":res.shipp.receiveDesc,
            "القيمة شاملة الشحن":res.shipp.charge,     
            ...(res.shipp.state===STATES_NAMES.DELIVERD)&&{"قيمة الشحن":res.shipp.fees},
            ...(res.shipp.state===STATES_NAMES.DELIVERD)&&{"صافي المبلغ":(res.shipp.charge-res.shipp.fees)},
            ...(res.shipp.state===STATES_NAMES.DELIVERD)&&{"حالة التوريد":CHARGE_STATES[res.shipp.chargeState]},          
            ...(Admin)&&{"الكابتن":res.shipp.captinId},        
            "تاريخ الإنشاء":new Date(res.shipp.createTime).toISOString().split('T')[0],   
            "تاريخ آخر إجراء":new Date(res.shipp.excuteTime).toISOString().split('T')[0],
            "ملاحظات":res.shipp.notices
         
          })
/* ...(Admin)&&{"اﻷحداث":res.shipp.logs}*/
          setShipp(res.shipp);
          setBusy(false);
        } catch (e) {
          setError((e as ApiError).message);
          setShipp({} as Shippment);
          setTempShipp({});
          setBusy(false);
        }
      }
      fetchData();
      
      },[])

      const getUserDetails = useCallback(
        async (e: FormEvent | MouseEvent) => {
          e.preventDefault();

          try{
            const res= await callEndpoint<getUserByIdRequest, getUserResponse>(withParams(ENDPOINT_CONFIGS.getUserById, shipp.senderId!))
            setSenderDtls(res.name+'-'+res.address+'-'+res.phone+'-'+USER_STATUS[res.status]);

          }catch{
            setSenderDtls('');
          }

        },
        [shipp]
      );
      
      if(busy){
        return(
          <div>
             <Flex minH={'100px'} margin={'auto'} align={'center'} justify={'center'} >
            <Spinner></Spinner>
            </Flex>
          </div>
        )
      }
      
if (error){
  return(
    
      <Flex minH={'100px'} margin={'auto'} align={'center'} justify={'center'} >
     {error}
     </Flex>
 
  );
}
   
      

return(
  <div>
      <Flex dir='rtl'
     minH={'100vh'}
     
     justify={'center'}
     bg='gray.50'>
     <Stack spacing={5} w={'full'} mx={'auto'} maxW={'lg'} py={5} px={6}>
       <Stack align={'center'}>
         <Heading fontSize={'2xl'} textAlign={'center'}>
           تفاصيل الطرد
         </Heading>           
       </Stack>
       <Box
         rounded={'lg'}
         bg='white'
         boxShadow={'lg'}
         p={8}>  
        <Stack spacing={1}>

            {/*!!error &&
               <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CloseIcon boxSize={'20px'} color={'white'} />
               <Text color="red.700">{error}</Text>             
               </Stack>
*/}

            {Object.keys(tempShipp!).map((key,i)=>(
              <div key={i}>
              <Flex id="id"direction={'row'}>                               
              <Text size={'xl'} fontWeight={'bold'} paddingLeft={1}>{key}: </Text>
              <Text onClick={key==='كود الراسل'? getUserDetails:undefined} 
              cursor={key==='كود الراسل'? 'pointer':undefined} 
              color={key==='كود الراسل'? 'blue':'gray.600' } 
               size={'md'} 
               pl={2}
               >{tempShipp![key]}</Text>
              
            </Flex>
            {(!!senderDetls && key==='كود الراسل') &&
              
              <Text>{senderDetls}</Text>  
              }
            <Divider orientation='horizontal' />  
             </div>
            ))}
</Stack>

</Box>
<Stack direction={'row'} justifyContent={'center'} spacing={8}>
  {((Admin || (is_captin && shipp.state===2))) &&
<a href={ROUTES.UPDATE_SHIPP(shipp?.id!)}>تحديث</a>
}
{(shipp.state !==4 && !is_captin) &&
<Link
  to={ROUTES.EDIT_SHIPP}
  state={{shipp:shipp}}
>تعديل</Link>
}
</Stack>
 </Stack>

</Flex>
</div>
)
}